import { useState } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";

import { QueryStats } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import SettingIcon from "@mui/icons-material/CellTower";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import CopyIcon from "@mui/icons-material/CopyAll";
import BrandingIcon from "@mui/icons-material/Copyright";
import DeleteIcon from "@mui/icons-material/Delete";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import PreviewIcon from "@mui/icons-material/Preview";
import RemoveIcon from "@mui/icons-material/Remove";
import AssessmentIcon from "@mui/icons-material/Rule";
import { Box, Grid, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { useTheme } from "@mui/material/styles";
import Tab from "@mui/material/Tab";
import { useSnackbar } from "notistack";
import { v4 as uuid } from "uuid";

import constants from "../../assets/constants";
import { themeDefinitions } from "../../assets/mui5themes";
import { createNewBotpressBot } from "../../data/omniDataModel";
import { deepCopyObject } from "../../utils/helpers";
import { isValidEmail } from "../../utils/helpers";
import TextInputDialog from "../dialogs/textInputDialog";
import OmniAssessmentTypeListItem from "../ui/omniAssessmentTypeListItem";
import OmniBotpressBotListItem from "../ui/omniBotpressBotListItem";
import Dialog from "../ui/omniDialog";
import DialogActions from "../ui/omniDialogActions";
import DialogContent from "../ui/omniDialogContent";
import DialogList from "../ui/omniDialogList";
import DialogTab from "../ui/omniDialogTab";
import DialogTabs from "../ui/omniDialogTabs";
import DialogTitle from "../ui/omniDialogTitle";
import OmniEditButton from "../ui/omniEditButton";
import OmniMenuItem from "../ui/omniMenuItem";
import OmniResponsiveButton from "../ui/omniResponsiveButton";
import OmniTextField from "../ui/omniTextField";
import AlertDialog from "./alertDialog";
import BotpressBotDialog from "./botpressBotDialog";

const OrganizationDialog = props => {
  const {
    open,
    dialogTitle = "Add Organization",
    okMessage = "OK",
    cancelMessage = "Cancel",
    deleteMessage = "Delete",
    maxWidth = "sm",
    fullWidth = true,
    awsGroup = "",
    omniDMO, //omni Data Model Object, a root level object representation, Pass in a COPY, the only way this works
  } = props;

  const { enqueueSnackbar } = useSnackbar();
  const theme = useTheme();

  const [editedDMO, setEditedDMO] = useState(omniDMO);
  const [editedAddress, setEditedAddress] = useState(omniDMO.omniData.address);

  const [orgType, setOrgType] = useState(
    omniDMO.omniData.organizationType
      ? omniDMO.omniData.organizationType
      : constants.organizationTypes[0].value,
  );

  const calculateAssessmentTypes = theType => {
    if (theType === constants.organizationTypeEnums.botpressTesting) {
      return constants.supportedAssessmentTypes.filter(assType =>
        assType.value.includes("botpress"),
      );
    } else {
      return constants.supportedAssessmentTypes.filter(
        assType =>
          !assType.value.includes("botpress") ||
          assType.value === editedDMO.omniData.defaultAsssesmentType,
      );
    }
  };

  const [supportedAssessmentTypes, setSupportedAssessmentTypes] = useState(
    calculateAssessmentTypes(orgType),
  );

  useEffect(() => {
    try {
      if (editedDMO.omniData.onboardingBanner) {
        const splitPath = editedDMO.omniData.onboardingBanner.split("/");
        setOnboardingBannerName(splitPath[splitPath.length - 1]);
      } else {
        setOnboardingBannerName("");
      }
      setSupportedAssessmentTypes(calculateAssessmentTypes(orgType));
    } catch (error) {
      console.log(error);
    }
  }, [orgType]);

  // Required Fields and Validation
  const [readyOk, setReadyOk] = useState(false);

  // Check Organization name
  const [organizationNameValid, setOrganizationNameValid] = useState(false);

  useEffect(() => {
    editedDMO.omniData.name ? setOrganizationNameValid(true) : setOrganizationNameValid(false);
  }, [editedDMO.omniData.name]);

  const [showOnboardingInputType, setShowOnboardingInputType] = useState(false);

  const [onboardingBannerName, setOnboardingBannerName] = useState("");
  useEffect(() => {
    try {
      if (editedDMO.omniData.onboardingBanner) {
        const splitPath = editedDMO.omniData.onboardingBanner.split("/");
        setOnboardingBannerName(splitPath[splitPath.length - 1]);
      } else {
        setOnboardingBannerName("");
      }
    } catch (error) {
      console.log(error);
    }
  }, [editedDMO.omniData.onboardingBanner]);

  const [onboardingBackgroundName, setOnboardingBackgroundName] = useState("");
  useEffect(() => {
    try {
      if (editedDMO.omniData.onboardingBackground) {
        const splitPath = editedDMO.omniData.onboardingBackground.split("/");
        setOnboardingBackgroundName(splitPath[splitPath.length - 1]);
      } else {
        setOnboardingBackgroundName("");
      }
    } catch (error) {
      console.log(error);
    }
  }, [editedDMO.omniData.onboardingBackground]);

  const [onboardingHTML, setOnboardingHTML] = useState("");
  useEffect(() => {
    try {
      if (editedDMO.omniData.onboardingHTML) {
        const splitPath = editedDMO.omniData.onboardingHTML.split("/");
        setOnboardingHTML(splitPath[splitPath.length - 1]);
      } else {
        setOnboardingHTML("");
      }
    } catch (error) {
      console.log(error);
    }
  }, [editedDMO.omniData.onboardingHTML]);

  const [postAssessmentHTML, setPostAssessmentHTML] = useState("");
  useEffect(() => {
    try {
      if (editedDMO.omniData.postAssessmentHTML) {
        const splitPath = editedDMO.omniData.postAssessmentHTML.split("/");
        setPostAssessmentHTML(splitPath[splitPath.length - 1]);
      } else {
        setPostAssessmentHTML("");
      }
    } catch (error) {
      console.log(error);
    }
  }, [editedDMO.omniData.postAssessmentHTML]);

  //Check Valid Source
  const [emailValidSource, setEmailValidSource] = useState(false);

  useEffect(() => {
    isValidEmail(editedDMO.omniData.emailSource)
      ? setEmailValidSource(true)
      : setEmailValidSource(false);
  }, [editedDMO.omniData.emailSource]);

  //Check Valid Return
  const [emailReturnPathValid, setEmailReturnPathValid] = useState(false);

  useEffect(() => {
    isValidEmail(editedDMO.omniData.emailReturnPath)
      ? setEmailReturnPathValid(true)
      : setEmailReturnPathValid(false);
  }, [editedDMO.omniData.emailReturnPath]);

  //Check Valid Reply
  const [emailReplyToAddressValid, setEmailReplyToAddressValid] = useState(false);

  useEffect(() => {
    try {
      //just do one for now
      isValidEmail(editedDMO.omniData.emailReplyToAddress)
        ? setEmailReplyToAddressValid(true)
        : setEmailReplyToAddressValid(false);
    } catch (error) {
      setEmailReplyToAddressValid(false);
    }
  }, [editedDMO.omniData.emailReplyToAddress]);

  //Ready OK check
  useEffect(() => {
    organizationNameValid && emailReturnPathValid && emailValidSource && emailReplyToAddressValid
      ? setReadyOk(true)
      : setReadyOk(false);
  }, [organizationNameValid, emailReturnPathValid, emailValidSource, emailReplyToAddressValid]);

  useEffect(() => {
    try {
      if (
        !editedDMO.omniData.supportedAssessmentTypes.includes(
          editedDMO.omniData.defaultAsssesmentType,
        )
      ) {
        editedDMO.omniData.supportedAssessmentTypes.push(editedDMO.omniData.defaultAsssesmentType);
        setEditedDMO(deepCopyObject(editedDMO));
      }
    } catch (error) {
      console.log(error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editedDMO.omniData.defaultAsssesmentType, editedDMO.omniData.supportedAssessmentTypes]);

  const toggleAssessment = id => {
    try {
      if (orgType === constants.organizationTypeEnums.botpressTesting) {
      }
      if (editedDMO.omniData.supportedAssessmentTypes.includes(id)) {
        let newArray = editedDMO.omniData.supportedAssessmentTypes.filter(
          element => element !== id,
        );
        editedDMO.omniData.supportedAssessmentTypes = newArray;
        setEditedDMO(deepCopyObject(editedDMO));
      } else {
        editedDMO.omniData.supportedAssessmentTypes.push(id);
        setEditedDMO(deepCopyObject(editedDMO));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const updateOrganizationODM = event => {
    try {
      editedDMO.omniData[event.target.id] = event.target.value;
      setEditedDMO(deepCopyObject(editedDMO));
    } catch (error) {
      console.log(error);
    }
  };

  const updateAddressDMO = event => {
    try {
      editedAddress[event.target.id] = event.target.value;

      setEditedAddress(deepCopyObject(editedAddress));
    } catch (error) {
      console.log(error);
    }
  };

  const [botpressBots, setBotpressBots] = useState(omniDMO.omniData.botpressBots);

  const [tabIndex, setTabIndex] = useState(0);
  const [showConfirm, setShowConfirm] = useState(false);
  const [botDefinitionODM, setBotDefinitionODM] = useState(null);

  const onAcceptHandler = () => {
    //notice we didn't touch the id
    editedDMO.omniData.address = editedAddress;
    editedDMO.omniData.emailTemplates = [];
    editedDMO.omniData.organizationType = orgType;
    editedDMO.omniData.botpressBots = botpressBots;
    if (orgType === constants.organizationTypeEnums.botpressTesting) {
      editedDMO.omniData.defaultAsssesmentType = constants.assessmentIDs.botpressDefault.value;
      editedDMO.omniData.supportedAssessmentTypes =
        editedDMO.omniData.supportedAssessmentTypes.filter(assType => assType.includes("botpress"));
    }

    props.onAccept(editedDMO);
  };

  const onCloseHandler = () => {
    props.onClose();
  };

  const onDeleteHandler = () => {
    props.onDelete(omniDMO);
  };
  ///////////////////////////////////////////

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          onCloseHandler();
        }
      }}
      disableEscapeKeyDown
      maxWidth={maxWidth}
      fullWidth={fullWidth}
    >
      <DialogTitle onClose={onCloseHandler}>{dialogTitle}</DialogTitle>
      <DialogTabs tabIndex={tabIndex} setTabIndex={setTabIndex}>
        <Tab
          key={`tab0`}
          icon={<InfoRoundedIcon />}
          label={organizationNameValid ? "Info" : "Info *"}
        />
        <Tab key={`tab1`} icon={<BrandingIcon />} label="Branding" />
        <Tab key={`tab2`} icon={<SettingIcon />} label="Comms" />
        <Tab key={`tab3`} icon={<AssessmentIcon />} label="Assessments" />
        <Tab key={`tab4`} icon={<QueryStats />} label="Botpress" />
      </DialogTabs>
      <DialogContent>
        {/* INFORMATION TAB */}
        <DialogTab selectedIndex={tabIndex} index={0}>
          {/* General Information  */}
          <Typography variant="overline" sx={{ marginTop: theme.spacing(1) }}>
            General Information
          </Typography>

          <Grid container>
            <Grid container item spacing={1}>
              <Grid item size={{ xs: 12, sm: 6 }}>
                <OmniTextField
                  label="Name"
                  type="textInput"
                  name={uuid()} //prevents AutoComplete Suggestions
                  variant="outlined"
                  id={"name"}
                  required
                  value={editedDMO.omniData.name}
                  error={!organizationNameValid}
                  onChange={event => {
                    updateOrganizationODM(event);
                  }}
                  placeholder={"The name for this new organization"}
                  autoFocus
                />
              </Grid>

              <Grid item size={{ xs: 10, sm: 5 }}>
                <OmniTextField
                  label="Organization Type"
                  type="textInput"
                  select
                  name={uuid()} //prevents AutoComplete Suggestions
                  variant="outlined"
                  id={"organizationType"}
                  value={orgType}
                  onChange={event => {
                    setOrgType(event.target.value);
                  }}
                  placeholder={"Type"}
                  disabled={awsGroup !== constants.userGroups.Creator}
                >
                  {constants.organizationTypes.map(orgType => (
                    <OmniMenuItem key={orgType.value} value={orgType.value}>
                      {orgType.label}
                    </OmniMenuItem>
                  ))}
                </OmniTextField>
              </Grid>

              <Grid item size={{ xs: 2, sm: 1 }}>
                <Box sx={{ position: "relative" }}>
                  <OmniEditButton
                    sx={{ top: 11 }}
                    title={"Copy GUID to Clipboard"}
                    disabled={omniDMO._id == null}
                    onClick={e => {
                      e.stopPropagation();
                      // setLockDisplayName(!lockDisplayName);
                      let onboardUrl = `${omniDMO._id}`;
                      navigator.clipboard.writeText(onboardUrl);

                      enqueueSnackbar("GUID Copied to Clipboard", {
                        variant: "success",
                      });
                    }}
                    icon={<ContentCopyOutlinedIcon size="large" />}
                  />
                </Box>
              </Grid>

              <Grid item size={{ xs: 12, sm: 12 }}>
                <OmniTextField
                  label="Full Business Name"
                  type="textInput"
                  name={uuid()} //prevents AutoComplete Suggestions
                  variant="outlined"
                  id={"legalName"}
                  value={editedDMO.omniData.legalName}
                  onChange={event => {
                    updateOrganizationODM(event);
                  }}
                  placeholder={"Full legal name"}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Location Information */}
          <Grid container>
            <Typography variant="overline" sx={{ marginTop: theme.spacing(1) }}>
              Location Information
            </Typography>
            <Grid container item spacing={1}>
              <Grid item size={{ xs: 12 }}>
                <OmniTextField
                  label="Street Address"
                  type="textInput"
                  name={uuid()} //prevents AutoComplete Suggestions
                  variant="outlined"
                  id={"streetAddress"}
                  value={editedAddress.streetAddress}
                  onChange={event => {
                    updateAddressDMO(event);
                  }}
                  placeholder={"The street address for this new organization"}
                />
              </Grid>
              <Grid item size={{ xs: 12, md: 5 }}>
                <OmniTextField
                  label="Locality"
                  type="textInput"
                  name={uuid()} //prevents AutoComplete Suggestions
                  variant="outlined"
                  id={"locality"}
                  value={editedAddress.locality}
                  onChange={event => {
                    updateAddressDMO(event);
                  }}
                  placeholder={"City or Locale of the organization"}
                />
              </Grid>
              <Grid item size={{ xs: 12, md: 2 }}>
                <OmniTextField
                  label="Region"
                  type="textInput"
                  name={uuid()} //prevents AutoComplete Suggestions
                  variant="outlined"
                  id={"region"}
                  value={editedAddress.region}
                  onChange={event => {
                    updateAddressDMO(event);
                  }}
                  placeholder={"State"}
                />
              </Grid>
              <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                <OmniTextField
                  label="Postal Code"
                  type="textInput"
                  name={uuid()} //prevents AutoComplete Suggestions
                  variant="outlined"
                  id={"postalCode"}
                  value={editedAddress.postalCode}
                  onChange={event => {
                    updateAddressDMO(event);
                  }}
                  placeholder={"Enter the postal, or zip, code for this organization"}
                />
              </Grid>
              <Grid item size={{ xs: 12, sm: 6, md: 2 }}>
                <OmniTextField
                  label="Country"
                  type="textInput"
                  name={uuid()} //prevents AutoComplete Suggestions
                  variant="outlined"
                  id={"country"}
                  value={editedAddress.country}
                  onChange={event => {
                    updateAddressDMO(event);
                  }}
                  placeholder={"USA"}
                />
              </Grid>
            </Grid>
          </Grid>
        </DialogTab>

        {/* BRANDING TAB */}
        <DialogTab selectedIndex={tabIndex} index={1}>
          <Typography variant="overline" sx={{ marginTop: theme.spacing(1) }}>
            Theme
          </Typography>
          <Grid container>
            <Grid container item spacing={1} size={{ xs: 12 }}>
              <Grid item size={{ xs: 6 }}>
                <OmniTextField
                  label="Select Theme"
                  select
                  id={"themeId"}
                  name={uuid()} //prevents AutoComplete Suggestions
                  variant="outlined"
                  value={editedDMO.omniData.themeId}
                  onChange={event => {
                    event.target["id"] = "themeId";
                    updateOrganizationODM(event);
                  }}
                >
                  {themeDefinitions.map((themeTemplate, index) => (
                    <OmniMenuItem key={themeTemplate.themeName} value={index.toString()}>
                      {themeTemplate.themeName}
                    </OmniMenuItem>
                  ))}
                </OmniTextField>
              </Grid>
            </Grid>
            <Typography variant="overline" sx={{ marginTop: theme.spacing(1) }}>
              Onboarding Banner
            </Typography>
            <Grid container item size={{ xs: 12 }}>
              <Box
                sx={{
                  whiteSpace: "nowrap",
                }}
              >
                <OmniResponsiveButton
                  tooltipTitle="Set Onboarding Banner"
                  buttonText={editedDMO.omniData.onboardingBanner ? "remove" : "select"}
                  icon={editedDMO.omniData.onboardingBanner ? <RemoveIcon /> : <AddIcon />}
                  component="label"
                  sx={{ marginLeft: theme.spacing(1) }}
                  onClick={event => {
                    if (editedDMO.omniData.onboardingBanner) {
                      event.target.value = "";
                      event.target["id"] = "onboardingBanner";
                      updateOrganizationODM(event);
                    } else {
                      setShowOnboardingInputType("onboardingBanner");
                    }
                  }}
                />

                <a
                  href={`${editedDMO.omniData.onboardingBanner}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <OmniResponsiveButton
                    tooltipTitle="Preview Onboarding Banner"
                    buttonText="Preview"
                    component="label"
                    icon={<PreviewIcon />}
                    disabled={!editedDMO.omniData.onboardingBanner}
                    sx={{ marginLeft: theme.spacing(1) }}
                  />
                </a>

                {onboardingBannerName && (
                  <Typography
                    variant="buttonText"
                    sx={{ marginLeft: theme.spacing(1), fontWeight: "bold" }}
                  >
                    {onboardingBannerName}
                  </Typography>
                )}
              </Box>
            </Grid>

            <Typography variant="overline" sx={{ marginTop: theme.spacing(1) }}>
              Onboarding Background
            </Typography>

            <Grid container item size={{ xs: 12 }}>
              <Box
                sx={{
                  whiteSpace: "nowrap",
                }}
              >
                <OmniResponsiveButton
                  tooltipTitle="Set the Onboarding Background"
                  buttonText={editedDMO.omniData.onboardingBackground ? "remove" : "select"}
                  icon={editedDMO.omniData.onboardingBackground ? <RemoveIcon /> : <AddIcon />}
                  component="label"
                  sx={{ marginLeft: theme.spacing(1) }}
                  onClick={event => {
                    if (editedDMO.omniData.onboardingBackground) {
                      event.target.value = "";
                      event.target["id"] = "onboardingBackground";
                      updateOrganizationODM(event);
                    } else {
                      setShowOnboardingInputType("onboardingBackground");
                    }
                  }}
                />

                <a
                  href={`${editedDMO.omniData.onboardingBackground}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <OmniResponsiveButton
                    tooltipTitle="Preview Onboarding Background"
                    buttonText="Preview"
                    component="label"
                    icon={<PreviewIcon />}
                    disabled={!editedDMO.omniData.onboardingBackground}
                    sx={{ marginLeft: theme.spacing(1) }}
                  />
                </a>
                {onboardingBackgroundName && (
                  <Typography
                    variant="buttonText"
                    sx={{ marginLeft: theme.spacing(1), marginTop: "44px", fontWeight: "bold" }}
                  >
                    {onboardingBackgroundName}
                  </Typography>
                )}
              </Box>
            </Grid>

            <Typography variant="overline" sx={{ marginTop: theme.spacing(1) }}>
              Onboarding HTML
            </Typography>

            <Grid container item size={{ xs: 12 }}>
              <Box
                sx={{
                  whiteSpace: "nowrap",
                  marginBottom: theme.spacing(1),
                }}
              >
                <OmniResponsiveButton
                  tooltipTitle="Set the Onboarding HTML"
                  buttonText={editedDMO.omniData.onboardingHTML ? "remove" : "select"}
                  icon={editedDMO.omniData.onboardingHTML ? <RemoveIcon /> : <AddIcon />}
                  component="label"
                  sx={{ marginLeft: theme.spacing(1) }}
                  onClick={event => {
                    if (editedDMO.omniData.onboardingHTML) {
                      event.target.value = "";
                      event.target["id"] = "onboardingHTML";
                      updateOrganizationODM(event);
                    } else {
                      setShowOnboardingInputType("onboardingHTML");
                    }
                  }}
                />

                <a
                  href={`${editedDMO.omniData.onboardingHTML}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <OmniResponsiveButton
                    tooltipTitle="Preview Onboarding HTML"
                    buttonText="Preview"
                    component="label"
                    icon={<PreviewIcon />}
                    disabled={!editedDMO.omniData.onboardingHTML}
                    sx={{ marginLeft: theme.spacing(1) }}
                  />
                </a>
                {onboardingHTML && (
                  <Typography
                    variant="buttonText"
                    sx={{ marginLeft: theme.spacing(1), marginTop: "44px", fontWeight: "bold" }}
                  >
                    {onboardingHTML}
                  </Typography>
                )}
              </Box>
            </Grid>
            <Typography variant="overline" sx={{ marginTop: theme.spacing(1) }}>
              Post Assessment HTML
            </Typography>

            <Grid container item size={{ xs: 12 }}>
              <Box
                sx={{
                  whiteSpace: "nowrap",
                  marginBottom: theme.spacing(1),
                }}
              >
                <OmniResponsiveButton
                  tooltipTitle="Set the PostAssessment HTML"
                  buttonText={editedDMO.omniData.postAssessmentHTML ? "remove" : "select"}
                  icon={editedDMO.omniData.postAssessmentHTML ? <RemoveIcon /> : <AddIcon />}
                  component="label"
                  sx={{ marginLeft: theme.spacing(1) }}
                  onClick={event => {
                    if (editedDMO.omniData.postAssessmentHTML) {
                      event.target.value = "";
                      event.target["id"] = "postAssessmentHTML";
                      updateOrganizationODM(event);
                    } else {
                      setShowOnboardingInputType("postAssessmentHTML");
                    }
                  }}
                />
                <a
                  href={`${editedDMO.omniData.postAssessmentHTML}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <OmniResponsiveButton
                    tooltipTitle="Preview PostAssessment HTML"
                    buttonText="Preview"
                    component="label"
                    icon={<PreviewIcon />}
                    disabled={!editedDMO.omniData.postAssessmentHTML}
                    sx={{ marginLeft: theme.spacing(1) }}
                  />
                </a>{" "}
                {postAssessmentHTML && (
                  <Typography
                    variant="buttonText"
                    sx={{ marginLeft: theme.spacing(1), marginTop: "44px", fontWeight: "bold" }}
                  >
                    {postAssessmentHTML}
                  </Typography>
                )}
              </Box>
            </Grid>
          </Grid>
        </DialogTab>

        {/* Communications */}
        <DialogTab selectedIndex={tabIndex} index={2}>
          <Grid container>
            <Grid container item spacing={1} size={{ xs: 12, sm: 12 }}>
              <Typography
                variant="overline"
                sx={{
                  marginTop: theme.spacing(1),
                  marginLeft: theme.spacing(1),
                  marginBottom: `-${theme.spacing(1)}`,
                }}
              >
                Organization Onboarding
              </Typography>
              <Grid item size={{ xs: 12 }}>
                <OmniResponsiveButton
                  tooltipTitle="Copy Link"
                  buttonText={"Default Onboarding Link"}
                  icon={<CopyIcon />}
                  component="label"
                  sx={{ marginLeft: theme.spacing(1), marginBottom: theme.spacing(2) }}
                  disabled={!editedDMO.omniData.sharedInviteKey}
                  onClick={() => {
                    let onboardUrl = `${window.location.origin}/onboarding?inviteKey=${editedDMO.omniData.sharedInviteKey}`;
                    navigator.clipboard.writeText(onboardUrl);
                    enqueueSnackbar("Link Copied to Clipboard", {
                      variant: "success",
                    });
                  }}
                />
              </Grid>
            </Grid>

            <Grid container item spacing={1} size={{ xs: 12, sm: 6 }}>
              <Typography
                variant="overline"
                sx={{
                  marginTop: theme.spacing(1),
                  marginLeft: theme.spacing(1),
                  marginBottom: `-${theme.spacing(1)}`,
                }}
              >
                SES Client Settings
              </Typography>
              <Grid item size={{ xs: 12 }}>
                <OmniTextField
                  label="Source Email"
                  type="textField"
                  name={uuid()} //prevents AutoComplete Suggestions
                  variant="outlined"
                  id={"emailSource"}
                  value={editedDMO.omniData.emailSource}
                  error={!emailValidSource}
                  onChange={event => {
                    updateOrganizationODM(event);
                  }}
                  placeholder={"Who are these from?"}
                  required
                  autoFocus
                />
              </Grid>
              <Grid item size={{ xs: 12 }}>
                <OmniTextField
                  label="Report To Email"
                  type="textField"
                  name={uuid()} //prevents AutoComplete Suggestions
                  variant="outlined"
                  id={"emailReturnPath"}
                  value={editedDMO.omniData.emailReturnPath}
                  error={!emailReturnPathValid}
                  onChange={event => {
                    updateOrganizationODM(event);
                  }}
                  placeholder={"Where do bounces go?"}
                  required
                />
              </Grid>
              <Grid item size={{ xs: 12 }}>
                <OmniTextField
                  label="Reply To Emails"
                  type="textField"
                  name={uuid()} //prevents AutoComplete Suggestions
                  variant="outlined"
                  id={"emailReplyToAddress"}
                  value={editedDMO.omniData.emailReplyToAddress}
                  error={!emailReplyToAddressValid}
                  onChange={event => {
                    updateOrganizationODM(event);
                  }}
                  placeholder={"Who do replies go to?"}
                  required
                  autoFocus
                />
              </Grid>
            </Grid>

            <Grid container item spacing={1} size={{ xs: 12, sm: 6 }}>
              <Typography
                variant="overline"
                sx={{
                  marginTop: theme.spacing(1),
                  marginLeft: theme.spacing(3),
                  marginBottom: `-${theme.spacing(1)}`,
                }}
              >
                SMS Client Settings
              </Typography>
              <Grid item size={{ xs: 12 }}></Grid>
            </Grid>
          </Grid>
        </DialogTab>

        {/* Assessments */}

        <DialogTab selectedIndex={tabIndex} index={3}>
          {orgType !== constants.organizationTypeEnums.botpressTesting && (
            <Typography variant="overline" sx={{ marginTop: theme.spacing(1) }}>
              Default Organization Assessment
            </Typography>
          )}
          {orgType !== constants.organizationTypeEnums.botpressTesting && (
            <Grid container item spacing={1}>
              <Grid item size={{ xs: 12 }}>
                <OmniTextField
                  label="Select Assessment"
                  select
                  id={"defaultAsssesmentType"}
                  name={uuid()} //prevents AutoComplete Suggestions
                  variant="outlined"
                  value={editedDMO.omniData.defaultAsssesmentType}
                  onChange={event => {
                    event.target["id"] = "defaultAsssesmentType";
                    updateOrganizationODM(event);
                  }}
                >
                  {supportedAssessmentTypes.map(assType => (
                    <OmniMenuItem key={assType.value} value={assType.value}>
                      {assType.info}
                    </OmniMenuItem>
                  ))}
                </OmniTextField>
              </Grid>
            </Grid>
          )}

          <Grid container spacing={1} size={{ xs: 12 }}>
            <Typography
              variant="overline"
              sx={{
                marginTop: theme.spacing(1),
                marginLeft: theme.spacing(1),
                marginBottom: `-${theme.spacing(1)}`,
              }}
            >
              Supported Assessment Types
            </Typography>

            <Grid container size={{ xs: 12 }}>
              <DialogList sx={{ padding: theme.spacing(1), width: "100%" }}>
                {supportedAssessmentTypes.map(assType => (
                  <OmniAssessmentTypeListItem
                    key={assType.value}
                    onClickHandler={() => toggleAssessment(assType.value)}
                    assessmentTypeDef={assType}
                    isChecked={editedDMO.omniData.supportedAssessmentTypes.includes(assType.value)}
                  />
                ))}
              </DialogList>
            </Grid>
          </Grid>
        </DialogTab>

        {/* Test Harness */}
        {orgType === constants.organizationTypeEnums.botpressTesting && (
          <DialogTab selectedIndex={tabIndex} index={4}>
            <Grid container spacing={1} size={{ xs: 12 }}>
              <Grid item size={{ xs: 6 }}>
                <Typography
                  variant="overline"
                  sx={{
                    marginLeft: theme.spacing(1),
                    marginBottom: `-${theme.spacing(1)}`,
                  }}
                >
                  Bot Definitions
                </Typography>
              </Grid>
              <Grid item container size={{ xs: 6 }} justifyContent="flex-end">
                <OmniResponsiveButton
                  tooltipTitle="Add new Botpress Bot Definition"
                  buttonText="Add bot"
                  component="label"
                  disabled={botDefinitionODM != null}
                  onClick={() => setBotDefinitionODM(createNewBotpressBot())}
                  botDefinitionODM
                />
              </Grid>
            </Grid>
            <Grid container spacing={1} size={{ xs: 12 }}>
              <DialogList sx={{ marginTop: theme.spacing(1), width: "100%" }}>
                {botpressBots.map(botDef => (
                  <OmniBotpressBotListItem
                    key={botDef._id}
                    botpressBotDef={botDef}
                    onClickHandler={setBotDefinitionODM}
                  />
                ))}
              </DialogList>
            </Grid>
          </DialogTab>
        )}
      </DialogContent>
      <DialogActions>
        <Box
          sx={{
            paddingRight: theme.spacing(2),
            paddingBottom: 0,
            display: "flex",
            flexDirection: "row",
            userSelect: "none",
            webkitUserSelect: "none",
            position: "relative",
            flexGrow: 1,
          }}
        >
          {awsGroup === constants.userGroups.Creator && (
            <OmniResponsiveButton
              icon={<DeleteIcon />}
              onClick={() => setShowConfirm(true)}
              buttonText={deleteMessage}
              tooltipTitle=""
            />
          )}
        </Box>
        <Box
          sx={{
            flexGrow: 0,
            flexShrink: 1,
          }}
        >
          {cancelMessage && (
            <Button
              onClick={onCloseHandler}
              color="secondary"
              variant="contained"
              sx={{ marginRight: theme.spacing(2) }}
            >
              {cancelMessage}
            </Button>
          )}
          <Button
            onClick={onAcceptHandler}
            color="secondary"
            disabled={!readyOk}
            variant="contained"
          >
            {okMessage}
          </Button>
        </Box>
      </DialogActions>

      {showConfirm && (
        <AlertDialog
          open={showConfirm}
          dialogTitle={`Confirm`}
          dialogMessage={"Are you sure you want to remove this organization?"}
          onAccept={() => {
            onDeleteHandler();
            setShowConfirm(false);
          }}
          onClose={() => {
            setShowConfirm(false);
          }}
        />
      )}

      {botDefinitionODM && (
        <BotpressBotDialog
          open={botDefinitionODM}
          omniODM={botDefinitionODM}
          onAccept={newBot => {
            let newBots = botpressBots.filter(obj => obj._id !== newBot._id);
            newBots.push(newBot);
            setBotpressBots(newBots);
            setBotDefinitionODM(null);
          }}
          onClose={() => {
            setBotDefinitionODM(null);
          }}
          onDelete={newBot => {
            let newBots = botpressBots.filter(obj => obj._id !== newBot._id);
            setBotpressBots(newBots);
            setBotDefinitionODM(null);
          }}
        />
      )}

      {showOnboardingInputType && (
        <TextInputDialog
          dialogTitle="Resource URL"
          dialogMessage={`Paste the Resource URL (Amazon S3 path) into this text box. This can 'technically' be any publicly accessable URL.`}
          inputLabel={`S3 Path`}
          open={showOnboardingInputType}
          onAccept={theText => {
            let fileName = {
              target: { id: showOnboardingInputType, value: theText },
            };
            updateOrganizationODM(fileName);
            setShowOnboardingInputType("");
          }}
          onClose={() => {
            setShowOnboardingInputType("");
          }}
        />
      )}
    </Dialog>
  );
};

const mapStateToProps = state => ({
  awsGroup: state.userSession.awsGroup,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationDialog);
